import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartBar,
  faChartLine,
  faChartPie,
  faChartArea,
  faFileLines,
  faFileExcel,
  faClipboard,
  faFolder,
  faLink,
  faBuilding,
  faCube,
  faBoxArchive,
  faHouse,
  faHashtag,
  faFont,
  faCheck,
  faXmark,
  faCalendar,
  faCircle,
  faTable,
  faArrowsRotate,
  faCamera,
  faTriangleExclamation,
  faThumbtack,
  faPuzzlePiece,
  faPenToSquare,
  faScroll,
  faFileImport,
  faDisplay,
} from '@fortawesome/free-solid-svg-icons';
// Per-widget icons are now defined in each widget's index.ts definition.
// Use getWidgetIcon(type) from registry.ts for lookups.

// Chart type sub-icons
export const CHART_TYPE_ICONS: Record<string, React.ReactNode> = {
  bar: <FontAwesomeIcon icon={faChartBar} />,
  line: <FontAwesomeIcon icon={faChartLine} />,
  pie: <FontAwesomeIcon icon={faChartPie} />,
  area: <FontAwesomeIcon icon={faChartArea} />,
  donut: <FontAwesomeIcon icon={faChartPie} />,
};

// Category icons (for DashboardBuilder sidebar)
export const WIDGET_CATEGORY_ICONS: Record<string, React.ReactNode> = {
  repositories: <FontAwesomeIcon icon={faBoxArchive} />,
  forms: <FontAwesomeIcon icon={faFileLines} />,
  microsoft: <FontAwesomeIcon icon={faFileExcel} />,
  external: <FontAwesomeIcon icon={faBuilding} />,
  shared: <FontAwesomeIcon icon={faLink} />,
  imports: <FontAwesomeIcon icon={faFileImport} />,
  display: <FontAwesomeIcon icon={faDisplay} />,
  input: <FontAwesomeIcon icon={faPenToSquare} />,
};

// Standalone / fallback icons
export const FALLBACK_WIDGET_ICON = <FontAwesomeIcon icon={faCube} />;

export const ASSET_TYPE_ICONS: Record<string, React.ReactNode> = {
  company: <FontAwesomeIcon icon={faBuilding} />,
  fund: <FontAwesomeIcon icon={faChartBar} />,
  property: <FontAwesomeIcon icon={faHouse} />,
  other: <FontAwesomeIcon icon={faFolder} />,
};

// Column data type icons (for data widget builders)
export const COLUMN_TYPE_ICONS: Record<string, React.ReactNode> = {
  integer: <FontAwesomeIcon icon={faHashtag} />,
  number: <FontAwesomeIcon icon={faHashtag} />,
  string: <FontAwesomeIcon icon={faFont} />,
  boolean: <FontAwesomeIcon icon={faCheck} />,
  date: <FontAwesomeIcon icon={faCalendar} />,
  datetime: <FontAwesomeIcon icon={faCalendar} />,
  default: <FontAwesomeIcon icon={faCircle} size="xs" />,
};

// Misc standalone icons
export const TABLE_ICON = <FontAwesomeIcon icon={faTable} />;
export const CHART_ICON = <FontAwesomeIcon icon={faChartBar} />;
export const REFRESH_ICON = <FontAwesomeIcon icon={faArrowsRotate} />;
export const CAMERA_ICON = <FontAwesomeIcon icon={faCamera} />;
export const CHECK_ICON = <FontAwesomeIcon icon={faCheck} />;
export const XMARK_ICON = <FontAwesomeIcon icon={faXmark} />;
export const WARNING_ICON = <FontAwesomeIcon icon={faTriangleExclamation} />;
export const PIN_ICON = <FontAwesomeIcon icon={faThumbtack} />;
export const PUZZLE_ICON = <FontAwesomeIcon icon={faPuzzlePiece} />;
export const EDIT_ICON = <FontAwesomeIcon icon={faPenToSquare} />;
export const SCROLL_ICON = <FontAwesomeIcon icon={faScroll} />;
export const LINK_ICON = <FontAwesomeIcon icon={faLink} />;
export const CLIPBOARD_ICON = <FontAwesomeIcon icon={faClipboard} />;
